import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActions,
    Button,
    Box,
} from '@mui/material';
import projectService from '../services/projectService';
import { Project } from '../types/project';

const DocumentationProjectSelect: React.FC = () => {
    const navigate = useNavigate();
    const [projects, setProjects] = useState<Project[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadProjects();
    }, []);

    const loadProjects = async () => {
        try {
            setLoading(true);
            const data = await projectService.getUserProjects();
            setProjects(data);
        } catch (error) {
            console.error('Error loading projects:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Select Project
            </Typography>

            <Grid container spacing={3}>
                {projects.map((project) => (
                    <Grid item xs={12} md={6} lg={4} key={project.id}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" component="h2">
                                    {project.name}
                                </Typography>
                                {project.description && (
                                    <Typography color="textSecondary" gutterBottom>
                                        {project.description}
                                    </Typography>
                                )}
                                <Typography variant="body2" color="textSecondary">
                                    Role: {project.role || 'Creator'}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={() => navigate(`/documentation/project/${project.id}`)}
                                >
                                    View Documentation
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {!loading && projects.length === 0 && (
                <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Typography color="textSecondary">
                        You don't have any projects yet. Create a project first.
                    </Typography>
                </Box>
            )}
        </Container>
    );
};

export default DocumentationProjectSelect; 